import type { CSSProperties } from 'react';
import MarkUnreadIconSvg from '../../assets/icons/mark_unread.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const MarkUnreadIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <MarkUnreadIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default MarkUnreadIcon;
